module.exports = __webpack_public_path__ + "img/zradirani.50427a36.gif";